const UNITED_STATES_CODE_ALIASES = ['US', 'USA'];

export const isUnitedStatesCode = (countryCode?: string | null) => UNITED_STATES_CODE_ALIASES.includes(countryCode?.toUpperCase() ?? '');

/**
 * Collapses a persisted country code to the ISO 3166-1 alpha-2 form that
 * `StationeryCountryShippingConstraint` matches against.
 *
 * Legacy drafts persisted the alpha-3 `'USA'`, and casing varies by entry point,
 * so a raw comparison against `'US'` silently fails every domestic shipping
 * constraint and leaves only the worldwide rate. Returns `''` for a missing code
 * so callers can keep using `|| fallbackCountryCode`.
 */
export const normalizeCountryCode = (countryCode?: string | null) => {
  const code = countryCode?.toUpperCase() ?? '';
  return isUnitedStatesCode(code) ? 'US' : code;
};
